import React, { useState, useEffect } from "react";
import { orderHistory } from "../services/orderService";
import { useNavigate,useParams } from "react-router-dom";
import { formatDateTime } from "../utils/dateFormatter";

const OrderHistory = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
const { hashcode } = useParams();
  useEffect(() => {
    fetchOrderHistory();
  }, []);

  const fetchOrderHistory = async () => {
    try {
      const response = await orderHistory();
      console.log("========> ", response);

      if (response.success) {
        setOrders(response.data || []);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Failed to load order history", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="container mt-4 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Order History</h2>

      {orders.length === 0 ? (
        <div className="alert alert-info">
          You haven't placed any orders yet.
        </div>
      ) : (
        <div className="row">
          {orders.map((order) => (
            <div key={order.id} className="col-md-6 mb-4">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <span>Order #{order.order_number}</span>
                  <span
                    className={`badge ${getStatusBadgeClass(
                      order.status
                    )} text-capitalize`}
                  >
                    {order.status}
                  </span>
                </div>

                <div className="card-body">
                  <p>
                    <strong>Date:</strong> {formatDateTime(order.created_at)}
                  </p>
                  <p>
                    <strong>Total:</strong> ₹{order.grand_total}
                  </p>
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => navigate(`/${hashcode}/orders/${order.id}`)}
                  >
                    View Details
                  </button>
                  {/* <h6>Items:</h6>
                  <ul className="list-group list-group-flush">
                    {order.order_items?.map((item) => (
                      <li
                        key={item.id}
                        className="list-group-item d-flex justify-content-between"
                      >
                        <span>
                          {item.item_name} × {item.quantity}
                        </span>
                        <span>₹{item.price * item.quantity}</span>
                      </li>
                    ))}
                  </ul> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// Status badge helper
const getStatusBadgeClass = (status) => {
  switch (status?.toLowerCase()) {
    case "completed":
      return "bg-success";
    case "preparing":
      return "bg-warning";
    case "pending":
      return "bg-info";
    case "cancelled":
      return "bg-danger";
    default:
      return "bg-secondary";
  }
};

export default OrderHistory;
